<template>
    <div v-if="themeStore.themeIndex === 1">
        <GiftCodeViewOne :data-set="dataSet" @pasteCode="pasteCode" @claimSubmit="claimSubmit" @goToShare="goToShare" />
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <GiftCodeViewTwo :data-set="dataSet" @pasteCode="pasteCode" @claimSubmit="claimSubmit" @goToShare="goToShare" />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <GiftCodeViewThree :data-set="dataSet" @pasteCode="pasteCode" @claimSubmit="claimSubmit" @goToShare="goToShare"
            :is-tab-view="isTabView" />
    </div>
    <div v-if="themeStore.themeIndex === 4">
        <GiftCodeViewFour :data-set="dataSet" @pasteCode="pasteCode" @claimSubmit="claimSubmit" @goToShare="goToShare"
            :is-tab-view="isTabView" />
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>
<script setup lang="ts">
import { onMounted, ref, computed } from 'vue';
import { Capacitor } from "@capacitor/core";
import { Clipboard } from '@capacitor/clipboard';
import { getRedeemcodeClaim } from '@/api/giftCode';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getActivityInformations } from '@/api/common';
import { Share } from '@capacitor/share';
import GiftCodeViewOne from '@/themes/themeOne/giftCode/giftCodeView.vue';
import GiftCodeViewTwo from '@/themes/themeTwo/giftCode/giftCodeView.vue';
import GiftCodeViewThree from '@/themes/themeThree/giftCode/giftCodeView.vue';
import GiftCodeViewFour from '@/themes/themeFour/giftCode/giftCodeView.vue';
import { GiftCodeData } from './giftCodeView';
import { useThemeStore } from '@/stores/theme';

const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const themeStore = useThemeStore()

const couponCode = ref('');
const activityInfo = ref([])
const bannerIcon = ref()
const props = defineProps<{
    isTabView?: boolean
}>()
const dataSet = computed<GiftCodeData>(() => ({
    activityInfo: activityInfo.value,
    bannerIcon: bannerIcon.value,
    couponCode: couponCode.value
}))

const pasteCode = async () => {
    if (Capacitor.isNativePlatform()) {
        const { type, value } = await Clipboard.read();
        couponCode.value = value;
    } else {
        // For web platform
        navigator.clipboard.readText()
            .then((text) => {
                couponCode.value = text;
            })
            .catch((err) => {
                console.error('Failed to get clipboard data', err);
            });
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getActivityInfo = () => {
    loadingRef.value.open();
    let data = {
        activityId: "redeem_code"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close();
        bannerIcon.value = res.data?.floatIcon
        activityInfo.value = JSON.parse(res.data?.activityIntro)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
const claimSubmit = (e: any) => {
    loadingRef.value.open()
    let data = {
        claimCode: e
    }
    getRedeemcodeClaim(data).then(res => {
        loadingRef.value.close()
        showSuccess(res?.msg)
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const goToShare = async () => {
    let shareLink = localStorage.getItem('shareLink')

    try {
        if (!shareLink) { return }
        await Share.share({
            text: shareLink,
        });
    } catch (error) {
        console.warn('Not supporting')
    }
}
onMounted(() => {
    getActivityInfo()
})
</script>
<style scoped></style>